
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[categoryId]",
      function () {
        return require("private-next-pages/c/[categoryId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[categoryId]"])
      });
    }
  